import Contributor from './contributor';

export default Contributor;
